<!-- <tradingview-widget [widgetConfig]="widgetConfig"></tradingview-widget> -->
<div class="app-tv-chart-container" id="tv_chart_container" [style.height.px]="myInnerHeight"></div>